// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2H5Gf","requiredAsterisk":"Info_requiredAsterisk__2paGL"};